import React, { FC } from 'react';
import s from './toyCartItem.module.scss';
import { Button } from '@components/UIKit/Button/Button';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
import cn from 'classnames';
interface ToysCartItemProps {
  className: string;
  clickHandler: () => void;
}
export const ToyCartItemRemove: FC<ToysCartItemProps> = ({
  className,
  clickHandler
}) => <Button id='default_button' className={cn(s.toyCartItem__squareBtn, className)} size={'small'} color={'Light-Red'} onClick={clickHandler} data-sentry-element="Button" data-sentry-component="ToyCartItemRemove" data-sentry-source-file="ToyCartItemRemove.tsx">
        <SpriteIcon name={'trash'} data-sentry-element="SpriteIcon" data-sentry-source-file="ToyCartItemRemove.tsx" />
    </Button>;